export default (state = {}, action) => {
  switch (action.type) {
    case "AUTH_LOGIN_FAILED":
      return action.payload;
    default:
      return state;
  }
};
